import { IGuestRating, IReservation, IUser } from '../interfaces';
import { Rating } from './rating';

export class GuestRating extends Rating implements IGuestRating {
  guestRated?: IUser;
  guestRatedId?: number;
  reservation?: IReservation;
  reservationId?: number;
  hidden?: boolean;
  adminHidden?: boolean;
  adminHiddenReason?: string | null;
  adminHiddenById?: number | null;
  adminHiddenAt?: string | Date | null;

  constructor(data?: IGuestRating) {
    super(data);

    if (data) {
      this.setData(data);
    }
  }

  override setData(data: IGuestRating): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }
  }
}
